import { __exports as Barcode } from "./index188.js";
var hasRequiredBarcode;
function requireBarcode() {
  if (hasRequiredBarcode) return Barcode;
  hasRequiredBarcode = 1;
  Object.defineProperty(Barcode, "__esModule", {
    value: true
  });
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  var Barcode$1 = function Barcode2(data, options) {
    _classCallCheck(this, Barcode2);
    this.data = data;
    this.text = options.text || data;
    this.options = options;
  };
  Barcode.default = Barcode$1;
  return Barcode;
}
export {
  requireBarcode as __require
};
//# sourceMappingURL=index158.js.map
